import { NgModule } from '@angular/core';
import { MatButtonModule, MatDialogModule } from '@angular/material';
import { DirectiveModule } from './directive';
import { ModalConfirmacaoComponent } from './modal-confirmacao';
import { UIModule } from './ui/ui.module';
import { ModalInfoComponent } from './modal-info/modal-info.component';

@NgModule({
  imports: [UIModule, DirectiveModule, MatDialogModule, MatButtonModule],
  exports: [UIModule, DirectiveModule],
  declarations: [ModalConfirmacaoComponent, ModalInfoComponent],
  entryComponents: [ModalConfirmacaoComponent, ModalInfoComponent]
})
export class SharedModule {
}
